var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D0E4FF",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7.666h.027c3.905.015 7.07 3.202 7.056 7.102v.077c-.053 2.788-1.729 5.1-3.125 6.55-.397.414-.82.812-1.256 1.183a.622.622 0 0 1-.808-.945c.404-.344.797-.714 1.167-1.099 1.242-1.29 2.732-3.327 2.778-5.711.012-3.275-2.597-5.902-5.817-5.915h-.023c-3.21 0-5.827 2.601-5.839 5.809a7.6 7.6 0 0 0 1.55 4.354c1.12 1.49 2.818 3.07 4.432 4.12a.62.62 0 0 1-.34 1.142.617.617 0 0 1-.34-.101c-1.727-1.125-3.547-2.816-4.746-4.413a8.84 8.84 0 0 1-1.8-5.06c.015-3.938 3.19-7.093 7.083-7.093Zm-1.455 7.178a1.453 1.453 0 0 0 2.904 0c0-.799-.651-1.45-1.452-1.45a.621.621 0 1 1 0-1.242 2.697 2.697 0 0 1 2.696 2.693 2.697 2.697 0 0 1-5.392 0 .621.621 0 0 1 1.244 0Z",
    fill: "#092593"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.4261aea09ea707e037ebf7bcaefd1c70.svg";
export { ForwardRef as ReactComponent };